import { NgClass, NgIf } from '@angular/common';
import { Component, DestroyRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmSidebar } from '@shared/models/sidebar.model';
import { Action, SidebarRefService } from '@shared/services/sidebar-ref.service';
import { AvatarModule } from 'primeng/avatar';
import { Button, ButtonDirective } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { Ripple } from 'primeng/ripple';
import { SidebarModule } from 'primeng/sidebar';
import { TextareaModule } from 'primeng/textarea';
@Component({
  selector: 'app-confirm-sidebar',
  imports: [
    Button,
    SidebarModule,
    AvatarModule,
    ButtonDirective,
    NgIf,
    TranslateModule,
    Ripple,
    NgClass,
    FormsModule,
    TextareaModule,
    ReactiveFormsModule,
    DrawerModule
  ],
  templateUrl: './confirm-sidebar.component.html',
  styleUrl: './confirm-sidebar.component.scss'
})
export class ConfirmSidebarComponent implements OnInit {
  sidebarVisible: boolean = true;
  @Input() data: ConfirmSidebar = {};
  @Output() action = new EventEmitter<any>();
  reasonForm: FormGroup;

  constructor(
    private sidebarRefService: SidebarRefService,
    private destroyRef: DestroyRef,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    if (this.data.isReasonSidebar) {
      this.reasonForm = this.fb.group({
        reason: ['', Validators.required]
      });
    }

    this.sidebarRefService.sidebarVisible$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      this.sidebarVisible = res;
    });
  }

  onHide() {
    this.sidebarRefService.emitAction(Action.CLOSE);
    this.sidebarVisible = false;
  }

  onClickCancel() {
    this.sidebarRefService.emitAction(Action.CANCEL);
    this.sidebarVisible = false;
  }

  private emitConfirmWithReason(reason: string) {
    this.sidebarRefService.emitAction(Action.CONFIRM);
    this.sidebarRefService.setReason(reason);
  }

  onClickOk() {
    if (this.data.isReasonSidebar && this.reasonForm) {
      if (this.reasonForm.valid) {
        const reason = this.reasonForm.get('reason')?.value;
        this.emitConfirmWithReason(reason);
      } else {
        this.reasonForm.markAllAsTouched();
      }
    } else {
      this.sidebarRefService.emitAction(Action.CONFIRM);
      // this.sidebarVisible = false;
    }
  }
}
